import React from "react";
import styles from "./GrünerSchulhof.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import img1 from "./assets/card1.jpg";



export const GrünerSchulhof = (props) => {
      const images = [img1];


  return (
    <>
    <section className={styles.intro}>
          <h1>Grüner Schulhof –Verantwortung leben, Gemeinschaft stärken</h1>
      <p>Grüner Schulhof –Verantwortung leben, Gemeinschaft stärken</p>
    </section>

    <div className="wrapper">
         <section className="wrapperContent">

          <div className={styles.text}>
            <p className={styles.text}>
                Im Schuljahr 2025/26 übernehmen unsere Schülerinnen und Schüler der Klassen drei bis
                sieben wöchentlich die Verantwortung für einen sauberen Schulhof. Dabei lernen sie
                Teamarbeit, Umweltbewusstsein und Eigenverantwortung – Werte, die unsere Schule auszeichnen und die Gemeinschaft nachhaltig stärken.
            </p>
          </div>
           <Swiper
                   className={styles.slider}
                   modules={[Navigation, Pagination, Autoplay]}
                   spaceBetween={20}
                   navigation
                   pagination={{ clickable: true }}
                   autoplay={{
                     delay: 3000,
                     disableOnInteraction: false,
                   }}
                   loop
                   breakpoints={{
                     320: { slidesPerView: 1 },
                     640: { slidesPerView: 2 },
                     1024: { slidesPerView: 3 },
                     1280: { slidesPerView: 4 },
                   }}
                 >
                   {images.map((src, i) => (
                     <SwiperSlide key={i}>
                       <img src={src} alt={`GrünerSchulhof ${i + 1}`} className={styles.image} />
                     </SwiperSlide>
                   ))}
                 </Swiper>
                 </section>

    </div>
 </>

  );
};
export default GrünerSchulhof;







